namespace Areas {
    "use strict";

    export function addCopySelectedContextMenu(e: any) {
        if (e.row.rowType === "data") {
            e.items = [{
                text: "Copy to selected",
                onItemClick: function () {
                    const grid = e.component as DevExpress.ui.dxDataGrid;
                    const row = e.row;
                    const column = e.column;

                    if (!column.allowEditing) return;

                    const cellValue = grid.cellValue(row.rowIndex, column.dataField);

                    var selKeys = grid.getSelectedRowKeys();
                    for (let i = 0; i < selKeys.length; i++) {
                        grid.cellValue(grid.getRowIndexByKey(selKeys[i]), column.dataField, cellValue);
                    }
                }
            }];
        }        
    }    
}